import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import heavyduty from "../../Images/Prima-5530_0.jpg";
import lightduty from "../../Images/The-Varied-Applications-of-Tata-Light-Trucks.jpg";
import smallduty from "../../Images/T.9.jpg";
import buses from "../../Images/tata-buses.jpeg";
import tippers from "../../Images/tippers.jpeg";

const vehicleData = [
  {
    img: heavyduty,
    label: "HCV",
    description: "Heavy Commercial Vehicles for demanding loads",
    route: "/mhcv"
  },
  {
    img: lightduty,
    label: "ICV",
    description: "Intermediate Commercial Vehicles for urban logistics",
    route: "/mhcv"
  },
  {
    img: smallduty,
    label: "MCV",
    description: "Medium Commercial Vehicles for versatile applications",
    route: "/mhcv"
  },
  {
    img: buses,
    label: "Buses",
    description: "Passenger transport solutions for every need",
    route: "/mhcv"
  }
];

const VehicleRange = () => {
  const navigate = useNavigate();

  const handleNavigation = (route) => {
    navigate(route);
  };

  return (
    <section className="px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true, amount: 0.5 }}
        >
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold ">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-700 to-blue-800">
              JANATHA AUTOMOBILES PVT LTD
            </span>
          </h1>
          <h2 className="text-xl sm:text-2xl md:text-3xl  font-bold pt-4 bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-blue-800">
            A Flagship Company of Janatha Group
          </h2>
          <p className="mt-4 text-lg md:text-xl text-gray-600 font-medium max-w-3xl mx-auto">
            Achieving Milestones, Securing Dreams
          </p>
        </motion.div>

        {/* Vehicle Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {vehicleData.map((item, index) => (
            <motion.div
              key={index}
              className="relative group overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 cursor-pointer"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, delay: index * 0.1, ease: "easeOut" }}
              onClick={() => handleNavigation(item.route)}
              whileHover={{ y: -10 }}
            >
              <div className="relative h-80 w-full overflow-hidden">
                <img
                  src={item.img}
                  alt={item.label}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
              </div>
              
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <motion.h3 
                  className="text-2xl font-bold mb-1"
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.3 }}
                >
                  {item.label}
                </motion.h3>
                <motion.p 
                  className="text-gray-300 text-sm"
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ delay: 0.4 }}
                >
                  {item.description}
                </motion.p>
                <motion.div
                  className="mt-3 flex items-center text-blue-300 group-hover:text-blue-100 transition-colors"
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ delay: 0.5 }}
                >
                  <span className="mr-2">Explore</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M14 5l7 7m0 0l-7 7m7-7H3"
                    />
                  </svg>
                </motion.div>
              </div>
              
              {/* Hover Indicator */}
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-blue-500 transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VehicleRange;